import { GrainOverlay } from "../components/effects/GrainOverlay";
import { useState, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { CustomCursor } from "../components/effects/CustomCursor";
import { ParticleField } from "../components/effects/ParticleField";
import { ReplayNav, ReplayMobileCTA } from "../components/replay/ReplayNav";
import { ReplayHero } from "../components/replay/ReplayHero";
import { Ticker } from "../components/sections/Ticker";
import { ReplayManifesto, AscensionPath, OfferStack, Guarantee } from "../components/replay/ReplayStory";
import { ReplayHost, Objections, ReplayFaq, BookingSection } from "../components/replay/ReplayClose";
import { Footer } from "../components/sections/Footer";
import { useAttribution } from "../hooks/useAttribution";
import { REPLAY_TICKER, REPLAY_DISCLOSURE, REPLAY_COPYRIGHT } from "../replayContent";

const REPLAY_SHAPES = ["key", "star", "seal", "check"];
const REPLAY_ANCHORS = [null, '[data-testid="replay-manifesto"]', "#host", "#book"];

export default function Replay() {
  const attribution = useAttribution();
  const [params] = useSearchParams();
  const [watchPct, setWatchPct] = useState(0);
  const defaultEmail = useMemo(() => params.get("email") || "", [params]);

  return (
    <div className="reg-app min-h-screen relative isolate" data-testid="replay-page">
      <GrainOverlay />
      <CustomCursor />
      <div className="hidden md:block fixed inset-0 z-0 pointer-events-none">
        <ParticleField shapeNames={REPLAY_SHAPES} anchorSelectors={REPLAY_ANCHORS} xOffset={-1.6} />
      </div>
      <ReplayNav />
      <main>
        <ReplayHero onMilestone={(m) => setWatchPct((p) => Math.max(p, m))} />
        <Ticker items={REPLAY_TICKER} />
        <ReplayManifesto />
        <AscensionPath />
        <OfferStack />
        <Guarantee />
        <ReplayHost />
        <Objections />
        <ReplayFaq />
          <BookingSection attribution={attribution} watchPct={watchPct} defaultEmail={defaultEmail} />
        <Footer disclosure={REPLAY_DISCLOSURE} version={REPLAY_COPYRIGHT} />
      </main>
      <ReplayMobileCTA />
    </div>
  );
}
